import { render, staticRenderFns } from "./Insalubrity.vue?vue&type=template&id=f23933e8&scoped=true&"
import script from "./Insalubrity.vue?vue&type=script&lang=js&"
export * from "./Insalubrity.vue?vue&type=script&lang=js&"
import style0 from "./Insalubrity.vue?vue&type=style&index=0&id=f23933e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23933e8",
  null
  
)

export default component.exports